import { render, staticRenderFns } from "./EstablishmentRoleFloatBtns.vue?vue&type=template&id=6648e148&"
import script from "./EstablishmentRoleFloatBtns.vue?vue&type=script&lang=js&"
export * from "./EstablishmentRoleFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports